import { Image, View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import type { AuthReminderSlide } from "./types";

export function AuthRemSlideContent({ slide }: { slide: AuthReminderSlide }) {
  return (
    <View className="flex w-full flex-row items-center gap-2">
      <View className="h-12 w-12 shrink-0">
        <Image src={slide.image} className="h-full w-full object-contain" />
      </View>
      <View className="flex min-w-0 flex-1 flex-col gap-1">
        <Typography variant="label-sm" color="foreground-default">
          {slide.title}
        </Typography>
        <Typography variant="caption-md" color="secondary-text">
          {slide.description}
        </Typography>
      </View>
    </View>
  );
}
